var map = {
	"./AliPay.png": "OD4p",
	"./BankAccount.png": "NRFM",
	"./Cash.png": "jFfz",
	"./Other.png": "j5pm",
	"./WeChat.png": "j59V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04/F";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fundaccount ^\.\/.*\.png$
// module id = 04/F
// module chunks = 30